import { QueueListIcon, AcademicCapIcon, LanguageIcon, Squares2X2Icon, SparklesIcon } from '@heroicons/react/24/outline';
import Routes from '@/router/Routes.ts';
import type { NavItem } from '@/layouts/Default/config-nav.tsx';

export const adminNavData: NavItem[] = [
  {
    title: 'Past Papers Management',
    path: Routes.ADMIN_PAST_PAPERS,
    icon: <QueueListIcon />,
  },
  {
    title: 'Grading Prompts',
    path: Routes.ADMIN_GRADING_PROMPTS,
    icon: <AcademicCapIcon />,
  },
  {
    title: 'Practice Questions',
    path: Routes.ADMIN_PRACTICE_QUESTIONS,
    icon: <LanguageIcon />,
  },
  {
    title: 'Question Categories',
    path: Routes.ADMIN_CATEGORIES,
    icon: <Squares2X2Icon />,
  },
  {
    title: 'Generation Prompts',
    path: Routes.ADMIN_QUESTION_GENERATION_PROMPTS,
    icon: <SparklesIcon />,
  },
];
